import * as rq from '@tanstack/react-query';

import { useDependencies } from '../../contexts/dependencies.context';
import type { IVehicleRepository } from '../../domain/repositories/vehicle.repository';

export namespace GetOneVehiclePreview {
  export const key = (input: Input) => ['get-one-vehicle-preview', input.id];

  export type Params = { refetchInterval?: number; enabled?: boolean };
  export type Input = IVehicleRepository.GetPreviewByIdInput;
  export type Output = IVehicleRepository.GetPreviewByIdOutput;

  export function useQuery(
    input: Input,
    { refetchInterval, enabled = true }: Params = {},
  ) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      enabled,
      queryKey: key(input),
      queryFn: () => repositories.vehicle.getPreviewById(input),
    });
  }
}
